import React from 'react'
import { SpreadsheetMapping, ColumnMapping, MidTradeAction, HaircutType, MidTradeResponse } from 'api'
import {
  ColumnsContainer,
  ColumnsHeaderPanel,
  ColumnsHeader,
  ColumnMappingStringPanel,
  ColumnMappingDatePanel,
  ColumnMappingDecimalPanel,
  ColumnMappingEnumPanel
} from '../upload/mappingDialog'
import { Locale, Translation } from 'locale'
import { MidTradeEventSpreadsheetParseResult } from './parseMidTradeEventSpreadsheet'
import { HaircutTypeHelper, MidTradeActionHelper, MidTradeResponseHelper } from 'model'

const NonParsableMidTradeActionsTypes = [MidTradeAction.RESIZE_WITH_RECALCULATED_COLLATERAL_PRICE]
export interface MidTradeMappingDialogColumnsProps {
  mapping: SpreadsheetMapping
  parseResult: MidTradeEventSpreadsheetParseResult
  incoming?: boolean
  onUpdate: (mapping: SpreadsheetMapping) => unknown
}

export const MidTradeEventMappingDialogColumns: React.FunctionComponent<MidTradeMappingDialogColumnsProps> = props => {
  const { mapping, parseResult, incoming, onUpdate } = props

  const handleColumnUpdate = (columnMapping: ColumnMapping, fieldName: keyof SpreadsheetMapping) =>
    onUpdate({ ...mapping, [fieldName]: columnMapping })

  return (
    <ColumnsContainer>
      <ColumnsHeaderPanel>
        <ColumnsHeader>{Locale.translate(Translation.TC_MID_TRADE_EVENTS_FIELD)}</ColumnsHeader>
        <ColumnsHeader>{Locale.translate(Translation.TC_SPREADSHEET_COLUMN)}</ColumnsHeader>
      </ColumnsHeaderPanel>

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_DEAL_ID)}
        fieldName="tradeId"
        columnMapping={mapping.tradeId}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      {incoming ? (
        <ColumnMappingEnumPanel
          fieldTitle={Locale.translate(Translation.TC_RESPONSE)}
          fieldName="response"
          columnMapping={mapping.response}
          parseResult={parseResult}
          Enum={MidTradeResponse}
          enumHelper={MidTradeResponseHelper}
          onUpdate={handleColumnUpdate}
        />
      ) : (
        <ColumnMappingEnumPanel
          fieldTitle={Locale.translate(Translation.TC_ACTION)}
          fieldName="action"
          columnMapping={mapping.action}
          parseResult={parseResult}
          excludeValues={NonParsableMidTradeActionsTypes}
          Enum={MidTradeAction}
          enumHelper={MidTradeActionHelper}
          onUpdate={handleColumnUpdate}
        />
      )}
      <ColumnMappingDecimalPanel
        fieldTitle={Locale.translate(Translation.TC_NOTIONAL, { amountFormat: null })}
        fieldName="notional"
        columnMapping={mapping.notional}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_RATE)}
        fieldName="rate"
        columnMapping={mapping.rate}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_HAIRCUT)}
        fieldName="haircut"
        columnMapping={mapping.haircut}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingEnumPanel
        fieldTitle={Locale.translate(Translation.TC_HAIRCUT_TYPE)}
        fieldName="haircutType"
        columnMapping={mapping.haircutType}
        parseResult={parseResult}
        Enum={HaircutType}
        enumHelper={HaircutTypeHelper}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingDatePanel
        fieldTitle={Locale.translate(Translation.TC_EFFECTIVE_DATE)}
        fieldName="effectiveDate"
        columnMapping={mapping.effectiveDate}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
    </ColumnsContainer>
  )
}
